export const logoUrl =
  "https://customer-assets.emergentagent.com/job_0e2883d8-b5b7-49a8-8298-25454d4437a4/artifacts/1lkpqtay_circle%20logo.png";

export const navLinks = [
  { label: "Home", to: "/", id: "home" },
  { label: "Platform", to: "/platform", id: "platform" },
  { label: "Solutions", to: "/solutions", id: "solutions" },
  { label: "How It Works", to: "/how-it-works", id: "how-it-works" },
  { label: "Partners", to: "/partners", id: "partners" },
  { label: "About", to: "/about", id: "about" },
  { label: "Contact", to: "/contact", id: "contact" },
];

export const capabilities = [
  {
    title: "AI Candidate Evaluation",
    description:
      "AI automatically evaluates, scores, and ranks candidates against your exact hiring criteria.",
  },
  {
    title: "Talent Network Sourcing",
    description:
      "Tap into a high-performance recruiter and vendor ecosystem to find qualified talent quickly.",
  },
  {
    title: "Structured Hiring Workflows",
    description:
      "Run every hiring stage with standardized workflows from requirements through onboarding.",
  },
  {
    title: "Workforce & Contractor Management",
    description:
      "Manage external workforce operations, approvals, and delivery quality in one unified layer.",
  },
];

export const platformModules = [
  {
    title: "AI Candidate Scoring",
    description:
      "Automatically evaluate and rank candidates based on skills and experience.",
  },
  {
    title: "Talent Network Engine",
    description:
      "Source candidates through recruiter and vendor ecosystem.",
  },
  {
    title: "Structured Hiring Pipeline",
    description:
      "Manage interviews, feedback, and hiring workflows.",
  },
  {
    title: "Hiring Intelligence Dashboard",
    description:
      "Real-time insights into hiring performance.",
  },
];

export const trustedStats = [
  "10,000+ Candidates Evaluated",
  "40% Faster Hiring",
  "500+ Recruiters in Network",
];

export const whoWeWorkWithCards = [
  {
    title: "Startups",
    description: "Scale hiring without building a large recruiting team.",
  },
  {
    title: "Enterprises",
    description: "Manage high-volume hiring pipelines with AI.",
  },
  {
    title: "Recruiter Partners",
    description: "Submit candidates and earn commissions.",
  },
];

export const processSteps = [
  "Share hiring requirements",
  "AI + talent network source candidates",
  "AI evaluates and ranks candidates",
  "Interviews and onboarding managed seamlessly",
];

export const footerSections = [
  {
    title: "Platform",
    links: [
      { label: "JobScore Matters", to: "/platform" },
      { label: "AI Candidate Evaluation", to: "/platform" },
      { label: "Hiring Workflow", to: "/how-it-works" },
    ],
  },
  {
    title: "Company",
    links: [
      { label: "About", to: "/about" },
      { label: "Careers", to: "/careers" },
      { label: "Contact", to: "/contact" },
    ],
  },
  {
    title: "Partners",
    links: [
      { label: "Recruiter Network", to: "/recruiter-network" },
      { label: "Vendor Network", to: "/vendor-network" },
    ],
  },
  {
    title: "Legal",
    links: [
      { label: "Privacy Policy", to: "/privacy-policy" },
      { label: "Terms of Service", to: "/terms-of-service" },
    ],
  },
];
